import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * Apollo Link to make sure our requests have re-try functionality in case of request failure
 * Docs: https://www.apollographql.com/docs/link/links/retry.html
 */
import { RetryLink } from 'apollo-link-retry';
export var EXPONENTIAL_BACKOFF_RETRY_POLICY = {
  INITIAL_DELAY: 200,
  MAX_RETRIES: 5,
  JITTER: true
};
export function is5xx(status) {
  return 500 <= status && status <= 599;
}
export var createRetryLink = function createRetryLink(retryOptions) {
  return new RetryLink({
    delay: _objectSpread({
      initial: EXPONENTIAL_BACKOFF_RETRY_POLICY.INITIAL_DELAY,
      max: Infinity,
      jitter: EXPONENTIAL_BACKOFF_RETRY_POLICY.JITTER
    }, retryOptions.delay),
    attempts: _objectSpread({
      max: EXPONENTIAL_BACKOFF_RETRY_POLICY.MAX_RETRIES,
      retryIf: function retryIf(error, operation) {
        var context = operation.getContext();
        var response = context.response;
        var noRetry = context.noRetry;
        return is5xx(response && response.status) && !noRetry;
      }
    }, retryOptions.attempts)
  });
};